export const categories = [
  { name: 'authorization-provided', description: 'Authorization Provided' },
  { name: 'subpoena-to-be-prepared', description: 'Subpoena to be prepared by EXL' },
  { name: 'authorization-not-provided', description: 'Authorization not provided - EXL to obtain' },
  { name: 'subpoena-provided', description: 'Subpoena provided' }
];
  
  export const levels = [
    { name: 'Normal', value: 'Normal' },
    { name: 'Rush', value: 'Rush ' }
  ];

  export const accountNames = [
    { name: 'Bolin Law Group', value: 'BLG' },
    { name: 'Burger Meyer LLP', value: 'BM ' }
  ];

  export const orderOwners = [
    { name: 'Zach Hodges', value: 'Zach' },
    { name: 'Dev CX Manager', value: 'devcxmgr' }
  ];
  
  export const titles = [
    { title: 'Attorney', value: 'attorney' },
    { title: 'Paralegal', value: 'paralegal' },
    { title: 'Other', value: 'other' }
  ];
  
  export const billers = [
    { name: 'Walmart', value: 'Walmart' },
    { name: 'B1', value: 'B1' },
    { name: 'B2', value: 'B1' },
    { name: 'B3', value: 'B1' }
  ];
  
  export const states = [
    { name: 'California', value: 'CA' },
    { name: 'Texas', value: 'TX' },
    { name: 'Florida', value: 'FL' },
    { name: 'New Jersey', value: 'NJ' }
  ];
  
  export const attachmentLabels = [
    { name: 'Authorization', value: 'Authorization' },
    { name: 'Subpoena', value: 'Subpoena' },
    { name: 'POA', value: 'POA' },
    { name: 'Other', value: 'OTH' }
  ];
  
  export const categoriesInExpectedOrder = [
    "authorization-provided",
    "subpoena-to-be-prepared",
    "authorization-not-provided",
    "subpoena-provided"
  ];
  
  export const billToNames = [
    { name: 'Walmart', email: 'walmart@gmail.com', value: 'Walmart ' }
  ];

  export interface State {
    name: string;
    value: string;
  }
  
  export interface Category {
    name: string;
    description: string;
  }
  
  export interface Level {
    name: string;
    value: string;
  }
  
  export interface ContactTitle {
    title: string;
    value: string;
  }
  
  export interface Contact {
    contactTitle: ContactTitle;
    contactBarNo: string | null;
    contactName?: string;
    contactPhone?: number;
    contactPhoneExtn?: string;
    contactEmail?: string;
    isNew?:boolean;
    keys?: any;
    showContactDropdown?:boolean;
  }
  
  export interface OrderInfo {
    orderInfoRefNum: string;
    orderInfoDate: string;
    selectedCategory: string;
    selectedLevel: boolean;
    orderInfoClientName: string;
    orderInfoBillTo: string;
    orderInfoBillToEmail: string;
    orderInfoAdjusterName: string;
    orderInfoAdjusterEmail: string;
    orderInfoAdjusterKeys: any;
    orderInfoBillingToKeys: any;
    orderInfoAttentionToKeys: any;
    orderInfoAttentionTo: string;
    orderInfoAttentionToFirmName: string;
    orderInfoAttentionToFirmPhone: string;
    orderInfoAttentionToFirmPhoneExtn: string;
    orderInfoAttentionToFirmAddress: string;
    orderInfoAttentionToFirmCity: string;
    orderInfoAttentionToFirmState: State;
    orderInfoAttentionToFirmZip: string;
    orderInfoAttachmentFile: Attachment[]; // Assuming file can be null or any other type
    orderInfoAttachmentLabel: any; // Assuming it can be null or any type
    orderInfoAttachmentExplanation: any; // Assuming it can be null or any type
    orderInfoSpecialInstructions: string;
    contacts: Contact[];
    orderInfoAccountName: string;
    orderInfoOrderOwner: string;
    adjusterDropdown: any;
    clientContactListId: string;
    accountContactListId: string;
    caseMatter?: string;
}
export interface AccountNames {
  name: string;
  value: string;
}

export interface OrderOwners {
  name: string;
  value: string;
}

export interface Attachment {
  label: any;
  filename: any;
  fileId: number;
  description: string;
  storageId: any;
  storageProviderId: any;
  type: any;
  size: any;
  sizeText: string;
  deleteDisabled?: boolean;
  isNew?: boolean;
  attachTo?: string;
  attributes?: { [key: string]: string };
}
export interface ClientNames {
  name: string;
  value: string;
}
  
export interface BillToNames extends ClientNames{
  email: string;
};
